// const mainUrl = "http://localhost:5000"
const mainUrl = "https://backend.bolorcargo.mn"

//auth urls
export const org_uri = mainUrl + "/org";
export const loginUri = mainUrl + "/admin";
export const logoutUri = mainUrl + "/org";

export const utils_uri = mainUrl + "/utils";
export const track_uri = mainUrl + "/track";

// git push https://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@github.com/bolorcargo/bolorcargo-backend.git